const storageKey = {
  playQQMusic: "playQQMusic"
  ,inputValue: "inputValue"
}
export default storageKey



// WEBPACK FOOTER //
// ./src/cnConst/storageKey.js